/**
 * @param {number} numSelectedRefinements - number of search results
 * @returns {string} mobile refinement button HTML
 */
export default numSelectedRefinements => `
    <button type="button" class="listing-options-button refinements-filter-show js-refinements-toggle hide-on-desktop" data-toggle="refinements-active">
        <span class="icon icon-filter2" aria-hidden="true"></span>
        <span class="listing-options-button-label">${window.Resources.SEARCH_FILTER}</span>
        ${numSelectedRefinements > 0 ? ` <span class="selected-options-count">${numSelectedRefinements}</span>` : ''}
    </button>
`;
